import { Grid, Typography } from '@material-ui/core';
import { RECORD_TYPE } from 'LixaniAPI/enums';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectPersonalRecordsFromToday } from 'scenes/WorkDemo/store/selectors/personalWorkCalendar.selectors';
import { selectSelectedRecord } from 'store/records/selectors/records.selectors';
import { calculateRecordsTotalTimesInSeconds } from './utils/calculateRecordsTotalTimesInSeconds';
import { formatTimeFromSeconds } from './utils/formatTimeFromSeconds';

export function WorkTimes() {
  const { t } = useTranslation();

  const recordsFromToday = useSelector(selectPersonalRecordsFromToday);

  const selectedRecord = useSelector(selectSelectedRecord);

  const workRecords = [];

  const breakRecords = [];

  const rideRecords = [];

  recordsFromToday.forEach((record) => {
    if (
      record.type === RECORD_TYPE.WORK ||
      record.type === RECORD_TYPE.PROJECTWORK
    ) {
      workRecords.push(record);
    } else if (
      [
        RECORD_TYPE.BREAK,
        RECORD_TYPE.BREAK_COFFEE,
        RECORD_TYPE.BREAK_MEAL,
      ].includes(record.type)
    ) {
      breakRecords.push(record);
    } else if (record.type === RECORD_TYPE.RIDE) {
      rideRecords.push(record);
    }
  });

  const [workTimeInSeconds, setWorkTimeInSeconds] = useState(
    calculateRecordsTotalTimesInSeconds(workRecords)
  );

  const [breakTimesInSeconds, setBreakTimesInSeconds] = useState(
    calculateRecordsTotalTimesInSeconds(breakRecords)
  );

  const [rideTimesInSeconds, setRideTimesInSeconds] = useState(
    calculateRecordsTotalTimesInSeconds(rideRecords)
  );

  // const paidBreakTime = (breakRecords, projectBreakRules) => {
  //   // calculate projects paid break time
  //   // prework before we get employer/project specific rules

  //   // add here the real limits
  //   const limitsByTypes = {
  //     [RECORD_TYPE.BREAK_COFFEE]: 12,
  //     [RECORD_TYPE.BREAK_MEAL]: 30,
  //     [RECORD_TYPE.BREAK]: 5,
  //   };

  //   let totalPaidTimeInMinutes = 0;

  //   breakRecords.forEach((breakRecord) => {
  //     const limitByType = limitsByTypes[breakRecord.type];

  //     const clockIn = moment(breakRecord.clockInAt).startOf('minute');
  //     const clockOut = moment(breakRecord.clockOutAt).startOf('minute');

  //     const diff = clockOut.diff(clockIn, 'minutes');

  //     if (diff > limitByType) {
  //       totalPaidTimeInMinutes += limitByType;
  //     } else {
  //       totalPaidTimeInMinutes += diff;
  //     }
  //   });
  //   return totalPaidTimeInMinutes;
  // };

  const selectedRecordBreaks = breakRecords.filter(
    (breakRecord) => breakRecord.parentRecordId === selectedRecord.id
  );

  const [selectedRecordWorkTimeInSeconds, setSelectedRecordTimeInSeconds] =
    useState(calculateRecordsTotalTimesInSeconds([selectedRecord]));
  const [selectedRecordBreakTimeInSeconds, setSelectedBreakTimeInSeconds] =
    useState(calculateRecordsTotalTimesInSeconds(selectedRecordBreaks));
  const [
    selectedRecordRidesTimeInSeconds,
    setSelectedRecordRidesTimeInSeconds,
  ] = useState(calculateRecordsTotalTimesInSeconds(rideRecords));

  useEffect(() => {
    const intervalId = setInterval(() => {
      const workSeconds = calculateRecordsTotalTimesInSeconds(workRecords);
      const breakSeconds = calculateRecordsTotalTimesInSeconds(breakRecords);
      const rideSeconds = calculateRecordsTotalTimesInSeconds(rideRecords);

      const selectedRecordWorkSeconds = calculateRecordsTotalTimesInSeconds([
        selectedRecord,
      ]);

      const selectedRecordBreakSeconds =
        calculateRecordsTotalTimesInSeconds(selectedRecordBreaks);

      setWorkTimeInSeconds(workSeconds);
      setBreakTimesInSeconds(breakSeconds);
      setRideTimesInSeconds(rideSeconds);
      setSelectedRecordTimeInSeconds(selectedRecordWorkSeconds);
      setSelectedBreakTimeInSeconds(selectedRecordBreakSeconds);
      setSelectedRecordRidesTimeInSeconds(rideSeconds);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="subtitle1" fontWeight="bold">
          {t('common.work_time')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={4}>
            {`${t('record.clocked_time')}:`}
          </Grid>
          <Grid item xs={4}>
            {formatTimeFromSeconds(selectedRecordWorkTimeInSeconds)}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={4}>
            {`${t('calendar.breaks')}:`}
          </Grid>
          <Grid item xs={4}>
            {formatTimeFromSeconds(selectedRecordBreakTimeInSeconds)}
          </Grid>
        </Grid>
      </Grid>
      {selectedRecordBreakTimeInSeconds ? (
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={4}>
              {`${t('calendar.rides')}:`}
            </Grid>
            <Grid item xs={4}>
              {formatTimeFromSeconds(selectedRecordRidesTimeInSeconds)}
            </Grid>
          </Grid>
        </Grid>
      ) : null}

      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={4}>
            {`${t('record.clocked_time_total')}:`}
          </Grid>
          <Grid item xs={4}>
            {formatTimeFromSeconds(workTimeInSeconds)}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Grid container>
          <Grid item xs={4}>
            {`${t('record.break_time_total')}:`}
          </Grid>
          <Grid item xs={4}>
            {formatTimeFromSeconds(breakTimesInSeconds)}
          </Grid>
        </Grid>
      </Grid>
      {rideTimesInSeconds ? (
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={4}>
              {`${t('record.ride_time_total')}:`}
            </Grid>
            <Grid item xs={4}>
              {formatTimeFromSeconds(rideTimesInSeconds)}
            </Grid>
          </Grid>
        </Grid>
      ) : null}
    </Grid>
  );
}
